import { Link } from "react-router-dom";

export const COLUMNS = [
   
    {
        Header: "Name",
        Footer: "Name",
        accessor: "name",
        disableFilters: true,
        sticky: "left",
    },

    {
        Header: "Email",
        Footer: "Email",
        accessor: "email",
    },
    {
        Header: "Contact Number",
        Footer: "Contact Number",
        accessor: "mobile",
    },

    {
        Header: "Membership Type",
        Footer: "Membership Type",
        accessor: "membership",
    },
  
    {
        Header: "Earned Value",
        Footer: "Earned Value",
        accessor: "earnedValue",
    },
    {
        Header: "Available Value",
        Footer: "Available Value",
        accessor: "availableValue",
    },
    {
        Header: "Redeem Value",
        Footer: "Redeem Value",
        accessor: "redeemValue",
    },
    
    // {
    //     Header: "Update Date",
    //     Footer: "Update Date",
    //     accessor: "updatedDate",
    // },

    {
         Header: "Action",
        Footer: "Action",
        accessor: "action",
    },
];
